<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">Cash Flow Issue</div>
      <el-form
        :model="param"
        :rules="rules"
        ref="login"
        class="ms-content"
        label-position="left"
        label-width="120px"
      >
        <el-form-item required label="User Type" prop="usertype">
          <el-select clearable v-model="param.usertype" placeholder="User Type">
            <el-option
              v-for="key in Object.values(UserType)"
              :key="key"
              :label="key"
              :value="key"
            />
          </el-select>
        </el-form-item>
        <template v-if="param.usertype === 'admin'">
          <el-form-item label="Password" prop="password">
            <el-input
              type="password"
              placeholder="password"
              v-model="param.password"
              @keyup.enter="submitForm(login)"
            >
            </el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="Room Number" prop="roomNumber">
            <el-input
              type="number"
              v-model="param.roomNumber"
              placeholder="Room Number"
            >
            </el-input>
          </el-form-item>
        </template>

        <div class="login-btn">
          <el-button type="primary" @click="submitForm(login)">login</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from "vue";
import { useTagsStore } from "../store/tags";
import { usePermissStore } from "../store/permiss";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { Lock, User } from "@element-plus/icons-vue";
import { ValueOf } from "element-plus/es/components/table/src/table-column/defaults";
import axios from "axios";
import { apiClient } from "../utils/request";

const UserType = {
  0: "admin",
  1: "overview",
  2: "Project Team Member",
  3: "Manufacturing Dept.",
  4: "IT Dept.",
  5: "Project Manager 1",
  6: "Project Manager 2",
  7: "Project Manager 3",
  8: "Project Manager 4",
  9: "Project Manager 5",
};

interface LoginInfo {
  username: string;
  password: string;
  usertype: ValueOf<typeof UserType>;
  roomNumber?: string;
}

const router = useRouter();
const param = reactive<LoginInfo>({
  usertype: "admin",
  username: "",
  password: "",
});

const rules: FormRules = {};
const permiss = usePermissStore();
const login = ref<FormInstance>();

function validateProjectManger(str) {
  // 使用正则表达式匹配数字部分
  const regex = /Project Manager (\d+)/;
  const match = str.match(regex);

  // 如果匹配成功，则返回匹配到的数字，否则返回null
  return match ? parseInt(match[1], 10) : 1;
}

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid: boolean) => {
    if (valid) {
      if (param.usertype === "admin") {
        if (param.password !== "admin123") {
          ElMessage.error("password not correct");
          return;
        }
      }
      if (param.usertype.startsWith("Project Manager")) {
        const pmCount = validateProjectManger(param.usertype);
        const roomInfo = await apiClient.get("/api/room/" + param.roomNumber);
        if (roomInfo.data.pmCount < pmCount) {
          ElMessage.error(
            "this room only have " + roomInfo.data.pmCount + " Project Manager"
          );
          return;
        }
      }
      sessionStorage.setItem("ms_usertype", param.usertype);
      if (param.roomNumber) {
        sessionStorage.setItem("roomNumber", param.roomNumber);
      }
      const keys = permiss.defaultList[param.usertype];
      permiss.handleSet(keys);
      sessionStorage.setItem("ms_keys", JSON.stringify(keys));
      ElMessage.success("login success");
      router.push("/");
    } else {
      ElMessage.error("login error");
      return false;
    }
  });
};

const tags = useTagsStore();
tags.clearTags();
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/login-bg.jpg);
  background-size: 100%;
}

.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}

.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.6);
  overflow: hidden;
}

.ms-content {
  padding: 30px;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}

.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>
